import { ComponentContador } from './libs/Contador.tsx'
import { useEvents } from './libs/Events'
import { Controller } from './assets/Controller.ts'
import { Buttons } from './assets/services/Buttons.ts'
import './App.css'
import { PlayIcon, PauseIcon, StopIcon, ArrowLeftStartOnRectangleIcon, ArrowLeftEndOnRectangleIcon } from '@heroicons/react/24/solid'
import { useAuth } from "react-oidc-context";
import { signOutRedirect } from './assets/services/Authentication.ts';
import { modeBanner } from './libs/ModeBanner.tsx'

function MainApp({ controller, buttons }: { controller: Controller, buttons: Buttons }) {

  return (
    <>
      <div className='absolute top-0 left-0 w-full'>
        {modeBanner()}
        <div className={'flex justify-end items-center gap-2 p-2'}>
          <span className="text-gray-500 dark:text-gray-400 p-2">Usuário: {controller.getUser()}</span>
          <button onClick={() => signOutRedirect()}><ArrowLeftStartOnRectangleIcon className="h-6 w-6 text-blue-500" /></button>
        </div>
      </div>
      <div className=" flex-col max-w-sm items-center gap-x-4 rounded-xl bg-white p-6 shadow-lg outline outline-black/5 dark:bg-slate-800 dark:shadow-none dark:-outline-offset-1 dark:outline-white/10">
        <div className="flex items-center px-5" style={{fontSize: '24px', fontWeight: 'bold' }}>
          <PlayIcon className="h-6 w-6 mr-2 text-blue-500" />
          <ComponentContador className="text-amber-100" contador={controller.playContador}/>
        </div>
        <div className="flex items-center px-5" style={{fontSize: '24px', fontWeight: 'bold' }}>
          <PauseIcon className="h-6 w-6 mr-2 text-blue-500" />
          <ComponentContador className="text-amber-100" contador={controller.pauseContador}/>
        </div>
      </div>
      <div className="mt-4 gap-x-4 flex w-full justify-between">
            <button 
              className="rounded-sm bg-blue-500 w-16 h-16  text-amber-50
               hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
              onClick={buttons.Entrada}
            >
              <PlayIcon className="h-full w-full" />
            </button>
            <button 
              className="rounded-sm bg-blue-500 w-16 h-16 text-amber-50 hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
              onClick={buttons.Pausa}
            >
              <PauseIcon className="h-full w-full" />
            </button>
            <button 
              className="rounded-sm bg-blue-500 w-16 h-16 text-amber-50 hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
              onClick={buttons.Saida}
            >
              <StopIcon className="h-full w-full" />
            </button>
          </div>
    </>
  )
}

function App() {
  const auth = useAuth();
  const {events, loaded} = useEvents(auth);

  if (auth.isLoading) {
    return <div>Loading...</div>;
  }

  if (auth.error) {
    return <div>Encountering error... {auth.error.message}</div>;
  }

  if (auth.isAuthenticated) {
    if (!loaded) {
      const controller = new Controller(auth);
      const buttons = new Buttons(controller);
      return <MainApp controller={controller} buttons={buttons} />;
    } else {
      const controller = new Controller(auth, events);
      const buttons = new Buttons(controller);
      return <MainApp controller={controller} buttons={buttons} />;
    }
  }

  return (
    <div>
      <div className='absolute top-0 left-0 w-full'>
        {modeBanner()}
      </div>
      <button onClick={() => auth.signinRedirect()} className="flex items-center justify-center mx-auto">
      <ArrowLeftEndOnRectangleIcon className="h-6 w-6 mr-2" /> 
      <div className='text-blue-500'> Login / Sign Up </div>
      </button>
    </div>
  );
}

export default App
